import {
    FaCheckCircle,
    FaLeaf,
    FaDrumstickBite,
    FaThLarge,
    FaTimesCircle,
    FaUtensils,
} from 'react-icons/fa';
import { getMenuCategoryIconMeta } from './menuCategoryIcons';

export const MENU_FOOD_TYPE_FILTER_OPTIONS = [
    {
        value: '',
        label: 'All food types',
        hint: 'Veg and non-veg items',
        Icon: FaUtensils,
        color: '#475569',
        bg: '#e2e8f0',
    },
    {
        value: 'VEG',
        label: 'Veg',
        hint: 'Vegetarian items only',
        Icon: FaLeaf,
        color: '#15803d',
        bg: '#dcfce7',
    },
    {
        value: 'NON-VEG',
        label: 'Non-Veg',
        hint: 'Non-vegetarian items only',
        Icon: FaDrumstickBite,
        color: '#b91c1c',
        bg: '#fee2e2',
    },
];

export const MENU_STATUS_FILTER_OPTIONS = [
    {
        value: '',
        label: 'All statuses',
        hint: 'Active and inactive items',
        Icon: FaThLarge,
        color: '#475569',
        bg: '#e2e8f0',
    },
    {
        value: 'ACTIVE',
        label: 'Active',
        hint: 'Available menu items',
        Icon: FaCheckCircle,
        color: '#15803d',
        bg: '#dcfce7',
    },
    {
        value: 'INACTIVE',
        label: 'Inactive',
        hint: 'Unavailable menu items',
        Icon: FaTimesCircle,
        color: '#b91c1c',
        bg: '#fee2e2',
    },
];

export function buildMenuCategoryFilterOptions(categoryOptions) {
    const base = [
        {
            value: '',
            label: 'All categories',
            hint: 'Every food category',
            Icon: FaThLarge,
            color: '#475569',
            bg: '#e2e8f0',
        },
    ];
    const items = (categoryOptions || []).map((opt) => {
        const iconMeta = getMenuCategoryIconMeta(opt.label ?? opt.value);
        return {
            value: opt.value,
            label: opt.label,
            hint: `${opt.label} only`,
            ...iconMeta,
        };
    });
    return [...base, ...items];
}
